<template>
  <div>
    <div class="form-group" v-for="field in fields" :key="`${field.key}_${block.id}`">
      <label :for="`${field.key}_${block.id}`" v-if="field.specification.type !== 'checkbox'">
        {{ field.specification.label }}
      </label>

      <component
        @field-update="handleFieldUpdate"
        :is="field.specification.type"
        :field="field"
        :id="`${field.key}_${block.id}`"
      ></component>

      <small class="form-text text-muted" v-if="field.specification.help">
        {{ field.specification.help }}
      </small>
    </div>
  </div>
</template>

<script>
  import textInput from './Fields/text-input';
  import richEditor from './Fields/rich-editor';
  import checkbox from './Fields/checkbox';
  import radio from './Fields/radio';
  import textArea from './Fields/text-area';
  import media from './Fields/media';
  import buttons from './Fields/buttons';
  import captions from './Fields/captions';
  import columns from './Fields/columns';
  import searchableScrollbox from './Fields/searchable-scrollbox';
  import searchableScrollboxGrouped from './Fields/searchable-scrollbox-grouped';
  import iconSelector from './Fields/icon-selector';
  import selectField from './Fields/select-field';
  import jsonLd from './Fields/json-ld.vue';
  import modules from './Fields/modules.vue';

  export default {
    props: ['block'],

    components: {
      textInput,
      richEditor,
      checkbox,
      radio,
      textArea,
      media,
      buttons,
      columns,
      searchableScrollbox,
      searchableScrollboxGrouped,
      iconSelector,
      captions,
      selectField,
      jsonLd,
      modules,
    },

    data() {
      return {
        currentFieldComponent: 'richEditor',
        fields: this.block.specification.fields.map(field => ({
          key: field.name,
          value: this.block.fields[field.name],
          specification: this.getSpecification(field.name),
        })),
      };
    },

    methods: {
      getSpecification(key) {
        const filtered = this.block.specification.fields.filter((field) => {
          return field.name === key;
        });

        return filtered.length ? filtered[0] : null;
      },

      handleFieldUpdate(name, val) {
        this.$emit('field-update', [this.block.id, name, val]);
      },
    },
  };
</script>
